module.exports = __webpack_public_path__ + "img/index7.0268a9d4.png";